module.exports = __webpack_public_path__ + "img/json.3e5a1246.svg";